import _debounce from 'lodash/debounce'

export default {
  methods: {
    showSuccessToast(message, duration = 3000) {
      // this.$toast.open({
      //   message: message,
      //   type: 'is-success',
      //   position: 'is-top',
      //   queue: false,
      //   duration: duration
      // })
      this.$notification.openNotificationWithType('success','',message,duration)

    },
    showQuoteChangedToast() {
      // this.$toast.open({
      //   message: 'Quote has changed. Please save before continuing',
      //   type: 'is-warning',
      //   position: 'is-top',
      //   queue: false,
      //   duration: 3000
      // })
      this.$notification.openNotificationWithType('warning','','Quote has changed. Please save before continuing',3000)

    },
    showToast: _debounce(function(message, type = 'success', location = 'top') {
      // this.$toast.open({
      //   message: message,
      //   type: `is-${type}`,
      //   position: `is-${location}`,
      //   queue: true,
      //   duration: 2000
      // })
      this.$notification.openNotificationWithType(type,'',message,2000)

    }, 500),

    /**
     * Checks for unsaved changes and either:
     * - If no changes: executes the action immediately
     * - If autosave enabled: saves first, then executes the action
     * - If autosave disabled: shows the "quote changed" toast and does NOT execute the action
     *
     * @param {Function} action - The async function to execute
     * @returns {Promise<boolean>} - true if action was executed, false if blocked
     */
    async saveAndContinue(action) {
      // Try to use parent's saveQuoteAndContinue if available (when component is a child of QuoteView)
      const parent = this.$parent
      if (parent && typeof parent.saveQuoteAndContinue === 'function') {
        const result = await parent.saveQuoteAndContinue(action)
        // Only warn when autosave is genuinely disabled. When autosave is on, a 'blocked'
        // (a modal/conflict is driving the UX) or 'failed' (the "Autosave Paused"
        // notification already covers it) result stays silent — there is no manual Save
        // to point the user at, so the "please save" toast would be a dead end.
        if (!result?.ok && result?.reason === 'autosave-disabled') {
          this.showQuoteChangedToast()
        }
        return !!result?.ok
      }

      // Fallback: check snapshotDiff directly (for components not under QuoteView)
      if (!this.snapshotDiff) {
        if (action && typeof action === 'function') {
          await action()
        }
        return true
      }

      // Has changes but no parent save method available
      this.showQuoteChangedToast()
      return false
    }
  }
}
